import LegalLayout from "@/components/LegalLayout";

export default function TermsOfService() {
  return (
    <LegalLayout
      testid="terms-of-service-page"
      title="Terms of Service"
      lastUpdated="February 2026"
    >
      <p>
        These Terms of Service ("Terms") govern the use of Brand-in-a-Box
        ("we", "us", "our") services. By submitting a proposal request or
        engaging our services, you agree to these Terms.
      </p>

      <h2>1. Service Description</h2>
      <p>
        Brand-in-a-Box provides professional branding and visual identity
        services, including logo design, brand identity systems, social
        templates, and related deliverables. Specific deliverables for each
        engagement are documented in a project scope agreement.
      </p>

      <h2>2. Scope Limitations</h2>
      <p>
        Work performed is strictly limited to deliverables defined in the
        signed scope agreement. Out-of-scope work requires a separate written
        agreement and additional fees.
      </p>

      <h2>3. Client Responsibilities</h2>
      <p>
        Clients agree to provide timely feedback, accurate information, and
        any required source assets (logos, copy, brand references). Delays
        caused by missing or late information may extend project timelines.
      </p>

      <h2>4. Intellectual Property</h2>
      <p>
        Upon full payment of all invoices, you receive commercial usage rights
        to final approved deliverables. Source files and editable assets are
        transferred as defined in your scope agreement. Pre-existing
        intellectual property and unused concepts remain the property of
        Brand-in-a-Box.
      </p>

      <h2>5. Payment Terms</h2>
      <p>
        Engagement begins only after an invoice is paid in accordance with the
        scope agreement. Production begins within 48 business hours of
        receipt of payment. Late payments may suspend the engagement.
      </p>

      <h2>6. Revision Terms</h2>
      <p>
        Each package includes a defined number of revision rounds documented
        in the scope agreement. Additional rounds may be quoted separately.
      </p>

      <h2>7. Project Timelines</h2>
      <p>
        Estimated timelines are provided in good faith and depend on timely
        client feedback. Delays in client review will proportionally extend
        delivery.
      </p>

      <h2>8. Confidentiality</h2>
      <p>
        Both parties agree to maintain confidentiality of non-public
        information shared during the engagement.
      </p>

      <h2>9. Liability Limitations</h2>
      <p>
        To the maximum extent permitted by law, our total liability for any
        claim arising from these Terms shall not exceed the total amount paid
        by the client for the specific engagement giving rise to the claim.
        We are not liable for indirect, incidental, or consequential damages.
      </p>

      <h2>10. Termination Rights</h2>
      <p>
        Either party may terminate the engagement in writing. If terminated by
        the client after production has begun, no refunds will be issued for
        work already performed. Brand-in-a-Box reserves the right to refuse
        or terminate engagements that violate these Terms or fall outside
        ethical, legal, or professional standards.
      </p>

      <h2>11. Governing Law</h2>
      <p>
        These Terms are governed by the laws of the jurisdiction in which
        Brand-in-a-Box is registered, without regard to conflict of law
        principles.
      </p>

      <h2>12. Contact</h2>
      <p>
        Questions about these Terms? Contact{" "}
        <a href="mailto:hello@bigeyedeassystems.com">hello@bigeyedeassystems.com</a>.
      </p>
    </LegalLayout>
  );
}
